module.exports = __webpack_public_path__ + "static/img/Report3D.82b5c879.png";